import * as angular from 'angular';

import { IRequestService } from '../';
import { IdentifierType, GoupValuesStatusDto } from '../../models';

export interface IIdentifierValuesStatusService {
    getBetweenDates(beginDateTime: string, endDateTime: string, identifierType: IdentifierType): angular.IPromise<{ [index: string]: { [index: number]: number } }>;
    getBetweenDates(beginDateTime: string, endDateTime: string, identifierType: IdentifierType, force: boolean): angular.IPromise<{ [index: string]: { [index: number]: number } }>;
    getOverview(beginDatetime: string, endDateTime: string, force: boolean): angular.IPromise<{ [groupGuid: string]: GoupValuesStatusDto }>;
}

export class IdentifierValuesStatusService implements IIdentifierValuesStatusService {
    static serviceId = 'identifierValuesStatusService';
    static $inject = ['requestService'];

    private _controllerUrl = 'identifierValuesStatus';

    constructor(private _requestService: IRequestService) {
    }

    getBetweenDates(beginDateTime: string, endDateTime: string, identifierType: IdentifierType);
    getBetweenDates(beginDateTime: string, endDateTime: string, identifierType: IdentifierType, force: boolean);
    getBetweenDates(beginDateTime: string, endDateTime: string, identifierType: IdentifierType, force?: boolean) {
        if (force) {
            this._requestService.cleanCacheAtV1(this._controllerUrl, { beginDateTime, endDateTime, identifierType });
        }
        return this._requestService.getAtV1(this._controllerUrl, { beginDateTime, endDateTime, identifierType });
    }

    getOverview(beginDateTime: string, endDateTime: string, force: boolean): angular.IPromise<{ [groupGuid: string]: GoupValuesStatusDto }> {
        const url = this._controllerUrl + '/overview';
        if (force) {
            this._requestService.cleanCacheAtV1(url, { beginDateTime, endDateTime });
        }
        return this._requestService.getAtV1(url, { beginDateTime, endDateTime });
    }
}